import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SearchFormBox = styled.div`
  ${mediaBreakpointUp.md} {
    width: 260px;
  }

  width: 210px;
  margin: 0 auto;
  text-align: center;
`;

export const ProgressIndicatorContainer = styled.div`
  ${mediaBreakpointUp.md} {
    padding: 0 32px;
  }
`;
